import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from 'angularfire2/auth';
declare var $:any;

export interface RouteInfo {
    path: string;
    title: string;
    icon: string;
    class: string;
}

export const ROUTES: RouteInfo[] = [
    { path: 'dashboard', title: 'Dashboard',  icon:'ti-stats-up', class: '' },
    { path: 'view', title: 'All Images',  icon: 'ti-image', class: '' },
    { path: 'upload', title: 'users',  icon:'ti-user', class: '' }
   /** { path: 'table', title: 'Table List',  icon:'ti-view-list-alt', class: '' },
    { path: 'typography', title: 'Typography',  icon:'ti-text', class: '' },
    
    { path: 'maps', title: 'Maps',  icon:'ti-map', class: '' },
    { path: 'notifications', title: 'Notifications',  icon:'ti-bell', class: '' },
    { path: 'upgrade', title: 'Upgrade to PRO',  icon:'ti-export', class: 'active-pro' },*/
];

@Component({
    moduleId: module.id,
    selector: 'sidebar-cmp',
    templateUrl: 'sidebar.component.html',
})

export class SidebarComponent implements OnInit {
    public menuItems: any[];
    constructor(public afAuth: AngularFireAuth) {}
    ngOnInit() {
        this.menuItems = ROUTES.filter(menuItem => menuItem);
    }
    isNotMobileMenu(){
        if($(window).width() > 991){
            return false;
        }
        return true;
    }

    signOut(){
        this.afAuth.auth.signOut();
    }

}



// WEBPACK FOOTER //
// /Users/makebetter/Documents/sportsceneDash/src/app/sidebar/sidebar.component.ts